module.exports = __webpack_public_path__ + "static/media/mirko_gropp.748f9ae7.png";